const A4_W = 595.276;
const A4_H = 841.89;

// Large A4 preview. `guides` draws the editable areas on screen only —
// they are CSS overlays and never part of any export.
export function PosterPreview({ image, layout, guides, busy, fits, testid = "poster-preview" }) {
  const bad = new Set((fits || []).filter((f) => !f.ok).map((f) => f.key));
  return (
    <div className="relative w-full bg-white border border-stone-200 rounded-xl shadow-sm overflow-hidden" style={{ aspectRatio: `${A4_W} / ${A4_H}` }} data-testid={testid}>
      {image
        ? <img src={image} alt="Poster preview" className="absolute inset-0 w-full h-full object-contain" data-testid={`${testid}-image`} />
        : <div className="absolute inset-0 bg-stone-100 animate-pulse" />}
      {guides && (layout?.fields || []).map((f) => (
        <div key={f.key} data-testid={`${testid}-guide-${f.key}`}
          className={`absolute border border-dashed pointer-events-none ${bad.has(f.key) ? "border-red-500 bg-red-500/10" : "border-[#dddd16] bg-[#dddd16]/10"}`}
          style={{ left: `${(f.x / A4_W) * 100}%`, top: `${(f.y / A4_H) * 100}%`, width: `${(f.width / A4_W) * 100}%`, height: `${(f.height / A4_H) * 100}%` }} />
      ))}
      {busy && (
        <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-stone-950/80 text-[#dddd16] text-[10px] font-bold uppercase tracking-wider" data-testid={`${testid}-updating`}>
          Updating preview…
        </div>
      )}
    </div>
  );
}
